
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/organisations",
      function () {
        return require("private-next-pages/organisations/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/organisations"])
      });
    }
  